<template>
  <div class="warp-content" style="padding-left: 25px;padding-right: 25px;padding-top: 45px;">
    <div class="header common-items-center" style="width: 100%;margin-bottom:35px">
      <img class="projectImg" v-if="edits.projectType==1" src="@/assets/custom-image/project/inconFire.png"/>
      <img class="projectImg" v-else src="@/assets/custom-image/project/incon-newEn.png"/>
      <div class="common-space-between common-flexw">
        <div>
          <div class="name">{{ edits.name }}</div>
          <div class="type">项目类型：{{ edits.projectType == 1 ? '消防' : '新能源' }}</div>
        </div>
        <div>
          <div class="common-items-center war-black" @click="$parent.setIsIf(true)">
            <div class="quan">
              <i class="el-icon-back" style="color:#087FFC"></i>
            </div>
            <span style="cursor: pointer;">返回</span>
          </div>
          <div class="tools" v-if="false">
            <el-button type="primary" class="btn" @click="click(0)" v-if="edits.roleType == 1">编辑</el-button>
            <el-button type="danger" class="btn" @click="click(1)" v-if="edits.roleType == 1">删除</el-button>
            <el-button type="defualt" class="btn" @click="click(2)" v-if="edits.roleType == 1">转让</el-button>
          </div>
        </div>
      </div>
    </div>
    <div class="common-items-center tabBtn">
      <el-button type='primary' :plain='tabIndex==1 ?  false : true' @click="btn(1)">项目基本信息</el-button>
      <el-button type="primary" :plain='tabIndex==2 ?  false : true' @click="btn(2)">项目施工图</el-button>
      <el-button type="primary" :plain='tabIndex==3 ?  false : true' @click="btn(3)">项目成员</el-button>
      <el-button type="primary" :plain='tabIndex==4 ?  false : true' @click="btn(4)">项目设备管理</el-button>
      <el-button type="primary" :plain='tabIndex==5 ?  false : true' @click="btn(5)">设备报警设置</el-button>
      <el-button type="primary" :plain='tabIndex==6 ?  false : true' @click="btn(6)">联动报警设置</el-button>
    </div> 
    <!--项目基本信息  -->
    <message  v-if="tabIndex == 1" :edits="edits"></message>
    <!--项目施工图  -->
    <drawing v-if="tabIndex == 2"  :edits="edits" operate="query"></drawing>
    <!--项目成员  -->
    <personnel v-if="tabIndex == 3" :edits="edits"></personnel>
    <!--项目设备管理  -->
    <device v-if="tabIndex == 4" :edits="edits"></device>
    <!--设备报警设置  -->
    <police v-if="tabIndex == 5" :edits="edits"></police>
    <!--设备报警设置  -->
    <linkage v-if="tabIndex == 6" :edits="edits"></linkage>
    <myDiglog :show="isShow">
        <add ref="add" :edits="edits" operate="edit" v-if="index == 0"></add>
        <makeover @setIsIf="setIsIf" ref="makeover" :data="edits" v-if="index == 1"></makeover>
    </myDiglog>
  </div>
</template>

<script>
import linkage from './linkage_police/block_linkage_police.vue'
import drawing from './drawing_construction/block_drawing_construction.vue'
import message from './components/block_query.vue'
import makeover from './components/block_makeover.vue'
import Add from "./components/block_add.vue";
import device from './device_management/block_device_management.vue'
import personnel from './personnel_management/block_personnel_management.vue'
import police from './police_disepose/block_police_management.vue'
import { url } from '@/utils/config'
import { deleteFun } from '@/utils/httpFun'

export default {
  props: {
    operate: {
      type: String,
      default: ''
    },
    edits: {
      type: Object,
      default: () => { }
    }
  },
  components: {
    message,
    drawing,
    device,
    personnel,
    police,
    Add,
    makeover,
    linkage
  },
  data() {
    return {
      proObj: '',
      isShow: false,
      index: 0,
      tabIndex: 1,
    }
  },
  mounted() {
    this.proObj = this.edits;
    console.log("====",this.edits)
  },
  methods: {
    close() {
      // this.$refs.add.clear();
      this.isShow = false;
    },
    click(index) {
      switch (index) {
        case 0:
          this.index = 0;
          this.isShow = true;
          this.$bus.$emit('setShow',true)
          this.$bus.$emit('setBtn', [
            {
              text: '确认',
              type: 'primary',
              callbalck: res => {
                this.$refs.add.addAgent();
              }
            },
            {
              text: '取消',
              callbalck: res => {
                this.$bus.$emit('setShow',false)
                this.isShow = false;
              }
            }
          ])
          this.$bus.$emit('setWidth', '1200px')
          this.$bus.$emit('setTitle', '编辑项目')
          break;
        case 1:
          this.$confirm('是否删除当前项目, 是否继续?', '删除', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(async () => {
            let param = {
              projectId: this.edits.id
            }
            await deleteFun(url.PROJECT.DELETEPROJECT, param, res => {
              console.log("删除", res);
              if (res.data) {
                this.$message.success("删除成功");
                this.$parent.setIsIf(true)
              } else {
                this.$message.success("删除失败");
              }
            })
          })
          break;
        case 2:
          this.index = 1;
          this.isShow = true;
          this.$bus.$emit('setShow',true)
          this.$bus.$emit('setBtn', [
            {
              text: '确认',
              type: 'primary',
              callbalck: res => {
                this.$refs.makeover.submit();
              }
            },
            {
              text: '取消',
              callbalck: res => {
                this.isShow = false;
                this.$bus.$emit('setShow',false)
              }
            }
          ])
          this.$bus.$emit('setWidth', '28%')
          this.$bus.$emit('setTitle', '转让项目')
          break;
      }
    },
    setIsIf(res){
      console.log('关闭项目信息')
      this.$parent.setIsIf(res)
    },
    btn(item) {
      this.tabIndex = item
    }
  }
}
</script>

<style lang="scss" scoped>
.projectImg {
  border-radius: 10px;
  height: 80px;
  width: 80px;
  margin-right: 28px;
}

.name {
  font-size: 28px;
  color: rgb(71, 78, 95);
  font-weight: 600;
}

.type {
  font-family: PingFangSC-Regular;
  font-size: 16px;
  color: rgb(19, 21, 26);
  font-weight: 400;
  margin-top: 10px;
}

.war-black {
  display: flex;
  justify-content: flex-end;
  padding-bottom: 16px;
}

.quan {
  border: 1px solid rgb(50, 59, 86, 0.6);
  width: 28px;
  height: 28px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  border-radius: 100%;
  margin-right: 10px;
}
.tabBtn{
   margin-top: 15px;
   border-bottom: 1px solid rgba(173, 173, 173, 0.4);
   padding-bottom: 15px;
   margin-bottom: 15px;
}


</style>